import api from '../../../App/socket';

export const addDivisions = (userId, divisions) => (
    api.send({
        api: 'module',
        module: 'UserManagement',
        classMethod: 'addUserToDivision',
        options: { userId, divisions },
    })
);

export const delDivisions = (userId, divisions) => (
    api.send({
        api: 'module',
        module: 'UserManagement',
        classMethod: 'delUserFromDivision',
        options: { userId, divisions },
    })
);



// WEBPACK FOOTER //
// ./src/modules/UserManagement/User_profile/requests/userDivisionsRequests.js